import { jsxs as p, jsx as a } from "react/jsx-runtime";
import { useState as h, useEffect as v } from "react";
import { I as g } from "./ic_arrowmore_fill-BlVN5kGZ.mjs";
import { c } from "./tw-cn-mXgPecoF.mjs";
import { D as b } from "./divider-CwxAn95O.mjs";
const w = ({ title: s, content: d, disabled: n, open: i, showDivider: o, onClick: l }) => {
  const f = (m) => {
    if (n) {
      m.preventDefault();
      return;
    }
    l == null || l(m);
  };
  return /* @__PURE__ */ p("div", { "aria-disabled": n, className: c("bg-static-white [&[open]>summary>svg]:rotate-180"), children: [
    /* @__PURE__ */ a(
      "h3",
      {
        className: c(
          "flex w-full cursor-pointer items-center gap-12",
          "active:bg-interaction-neutral-presshover-weak1 hover-never:bg-interaction-neutral-presshover-weak1",
          {
            "active:bg-static-white hover-never:bg-static-white": n
          }
        ),
        children: /* @__PURE__ */ p(
          "button",
          {
            "aria-expanded": i,
            className: c("flex min-h-48 w-full items-center justify-between gap-6", {
              "cursor-not-allowed text-interaction-neutral-disable-main": n
            }),
            onClick: f,
            type: "button",
            children: [
              /* @__PURE__ */ a("span", { className: "flex gap-6 typography-body-14-bold", children: s }),
              /* @__PURE__ */ a(
                g,
                {
                  className: c("size-16", { "rotate-180": i, "text-interaction-neutral-disable-main": n })
                }
              )
            ]
          }
        )
      }
    ),
    !!o && /* @__PURE__ */ a(b, {}),
    /* @__PURE__ */ a("div", { className: c("hidden", { block: i }), children: d })
  ] });
}, x = ({ items: s, className: d, showDivider: n, multiple: i = !1, onClick: o }) => {
  const [l, f] = h([]), m = (t, e) => {
    f((r) => i ? r.includes(e) ? r.filter((u) => u !== e) : [...r, e] : r.includes(e) ? [] : [e]), o == null || o(t, e);
  };
  return v(() => {
    if (i) {
      const t = s.map((e, r) => e.initialOpen ? r : -1).filter((e) => e !== -1);
      f(t);
    } else {
      const t = s.findIndex((e) => e.initialOpen);
      t !== -1 && f([t]);
    }
  }, [s, i]), /* @__PURE__ */ a("div", { className: c("flex flex-col", d), children: s.map((t, e) => /* @__PURE__ */ a("div", { children: /* @__PURE__ */ a(
    w,
    {
      ...t,
      onClick: (r) => {
        m(r, e);
      },
      open: l.includes(e),
      showDivider: n
    }
  ) }, `item_${e.toString()}`)) });
};
x.displayName = "NDS.Accordion";
export {
  w as A,
  x as a
};
